<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">GÜNLÜK KUR YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchDailyCurrencies = !showSearchDailyCurrencies">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Kur Arama</span>
        </h2>

        <div v-if="showSearchDailyCurrencies" class="card-bg p-5">
          <form @submit.prevent="getDailyCurrencies()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Tarih</b></label>
                <vs-input @change="getDailyCurrencies()" class="w-full" type="date" v-model="dailyCurrencySearch.date" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Döviz</b></label>
                <v-select @input="getDailyCurrencies()" name="Id" v-model="dailyCurrencySearch.currencyType" placeholder="Döviz Seçiniz" :options="currencyList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>

      <div class="card-bg mb-5 p-5">
        <h2 class="text-center hoverHeading">
          <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Kurlar</span>
        </h2>

        <div class="vx-row w-full">
          <div class="vx-col w-full mb-5">
            <vs-table search :maxItems="10" :pagination="true" :data="dailyCurrencyList">
              <template slot="thead">
                <vs-th>Tarih</vs-th>
                <vs-th>Döviz Id</vs-th>
                <vs-th>Döviz Türü</vs-th>
                <vs-th>Kur</vs-th>
                <vs-th>İşlemler</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(tr, i) in data">
                  <template v-if="tr.date">
                    <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 20%;">
                      <b> {{ tr.date }}</b>
                    </vs-td>

                    <vs-td class="pt-0 pb-1" style="width: 20%;">
                      <b> {{ tr.currencyType }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1" style="width: 20%;">
                      <b> {{ tr.currency }}</b>
                    </vs-td>
                    <vs-td class="pt-0 pb-1">
                      <vs-input type="number" v-model="tr.value" style="width: 50%;" />
                    </vs-td>

                    <vs-td style="width: 10%;">
                      <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveDailyCurrencies(tr, 'Update', '')" />
                    </vs-td>
                  </template>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      dailyCurrencyList: [],
      currencyList: [],
      dailyCurrencySearch: { date: null, currencyType: null, value: null },
      showSearchDailyCurrencies: false,
    };
  },
  computed: {},
  methods: {
    getDailyCurrencies: async function () {
      this.$vs.loading();
      this.dailyCurrencyList = await repository.postEntity("ParametricScreens/GetDailyCurrencies", this.dailyCurrencySearch).then((r) => r.list);
      console.log("daily", this.dailyCurrencyList);
      this.$vs.loading.close();
    },
    getCurrencies: async function () {
      this.$vs.loading();
      this.currencyList = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
      console.log("currency", this.currencyList);
      this.$vs.loading.close();
    },

    SaveDailyCurrencies: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveDailyCurrencies", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.dailyCurrencySearch = {};
      this.getDailyCurrencies();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getDailyCurrencies(), this.getCurrencies()]);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
